const PRINT_BEHAVIOR_STORAGE_KEY = 'posPrintBehaviorSettings';

const DEFAULT_PRINT_BEHAVIOR_SETTINGS = {
    kot: true,
    completeOrder: true,
    tempBill: true,
    finalBill: true
};

const normalizePrintBehaviorSettings = (settings) => {
    const source = settings && typeof settings === 'object' ? settings : {};
    return {
        kot: source.kot !== undefined ? Boolean(source.kot) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.kot,
        completeOrder: source.completeOrder !== undefined ? Boolean(source.completeOrder) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.completeOrder,
        tempBill: source.tempBill !== undefined ? Boolean(source.tempBill) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.tempBill,
        finalBill: source.finalBill !== undefined ? Boolean(source.finalBill) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.finalBill
    };
};

export const getDefaultPrintBehaviorSettings = () => ({ ...DEFAULT_PRINT_BEHAVIOR_SETTINGS });

export const getPrintBehaviorSettings = () => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return getDefaultPrintBehaviorSettings();
    }

    try {
        const raw = window.localStorage.getItem(PRINT_BEHAVIOR_STORAGE_KEY);
        if (!raw) {
            return getDefaultPrintBehaviorSettings();
        }

        const parsed = JSON.parse(raw);
        return normalizePrintBehaviorSettings(parsed);
    } catch (error) {
        console.warn('Unable to parse print behavior settings, using defaults.', error);
        return getDefaultPrintBehaviorSettings();
    }
};

export const savePrintBehaviorSettings = (settings) => {
    const normalized = normalizePrintBehaviorSettings(settings);

    if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(PRINT_BEHAVIOR_STORAGE_KEY, JSON.stringify(normalized));
    }

    return normalized;
};

export const resetPrintBehaviorSettings = () => {
    const defaults = getDefaultPrintBehaviorSettings();
    return savePrintBehaviorSettings(defaults);
};

export const isPrintActionEnabled = (actionKey) => {
    const settings = getPrintBehaviorSettings();
    return Boolean(settings[actionKey]);
};
